var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-bar'),_c('landing'),_c('specialty'),_c('div',{staticStyle:{"background-color":"#FFFFFF"}},[(_vm.$vuetify.breakpoint.mdAndUp ? true : false)?_c('card-carousel',{staticStyle:{"background-color":"#011E4A"}}):_vm._e(),_c('customers')],1),_c('partners'),_c('testimony'),_c('contactUs'),_c('rooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }